import { render, staticRenderFns } from "./flaggedOrdersTable.vue?vue&type=template&id=6e64f950"
import script from "./flaggedOrdersTable.vue?vue&type=script&lang=js"
export * from "./flaggedOrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports